import React, { useState, useEffect } from 'react';

// import link
import { Link, animateScroll as scroll } from 'react-scroll';
// import icon
import { BsHandIndexThumb } from 'react-icons/bs'
import { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';

const BackTopBtn = () => {
  const [show, setShow] = useState(false);
  const { Theme } = useContext(ThemeContext)
  useEffect(() => {
    window.addEventListener('scroll', () => {
      return window.scrollY > 600 ? setShow(true) : setShow(false);
    });
  });
  const scrollToTop = () => {
    scroll.scrollToTop();
  };
  {
    return (
      show && (
        <div>
           <button
          onClick={() => scrollToTop()}
          className={`animate-bounce ${Theme === "dark" ? "bg-[#F2AA4CFF]" : "bg-red-400"} lk hover:bg-accent-hover text-${ Theme === 'dark' ? 'black-400' : "white"} w-12 h-12 rounded-full fixed right-10 bottom-10 cursor-pointer flex justify-center items-center transition-all `}
        >
          <BsHandIndexThumb className='w-6 h-6' />
        </button>
        </div>
      )
    );
  }
};

export default BackTopBtn;
